import { createFileRoute } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { OverviewReportPage } from '@/features/reports/overview/overview-report-page'
import { formatDocumentTitle } from '@/lib/document-title'

/** Reports › Overview at `/$orgId/reports`, the page owners land on; open to every report viewer. */
export const Route = createFileRoute('/_auth/$orgId/reports/')({
  component: ReportsOverviewRoute,
})

function ReportsOverviewRoute() {
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Reports')}</title>
      </Helmet>
      <OverviewReportPage />
    </>
  )
}
